import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface BrandingState {
  visible: boolean;
  toggle: () => void;
}

export const useBranding = create<BrandingState>()(
  persist(
    (set) => ({
      visible: true,
      toggle: () => set((s) => ({ visible: !s.visible })),
    }),
    { name: 'ss-branding-v1' },
  ),
);
